// This file was auto-generated by querybuilder/Apollo and should not be edited.

import * as ExtendedFormFieldErrors from './ExtendedFormFieldErrors';
import * as OnboardingScaffolding from './OnboardingScaffolding';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { OnboardingStep3Input } from "./globalTypes";

// ====================================================
// GraphQL mutation operation: OnboardingStep3Mutation
// ====================================================

export interface OnboardingStep3Mutation_output_errors_extendedMessages {
  /**
   * A human-readable validation error.
   */
  message: string;
  /**
   * A machine-readable representation of the error.
   */
  code: string | null;
}

export interface OnboardingStep3Mutation_output_errors {
  /**
   * The camel-cased name of the input field, or '__all__' for non-field errors.
   */
  field: string;
  /**
   * A list of validation errors with extended metadata.
   */
  extendedMessages: OnboardingStep3Mutation_output_errors_extendedMessages[];
}

export interface OnboardingStep3Mutation_output_session_onboardingScaffolding {
  firstName: string;
  lastName: string;
  preferredFirstName: string;
  street: string;
  city: string;
  isCityInNyc: boolean | null;
  /**
   * Whether the onboarding user is in Los Angeles County. If we don't have enough information to tell, this will be null.
   */
  isInLosAngeles: boolean | null;
  state: string;
  borough: string;
  zipCode: string;
  aptNumber: string | null;
  email: string;
  phoneNumber: string;
  leaseType: string;
  receivesPublicAssistance: boolean | null;
  hasLandlordEmailAddress: boolean | null;
  hasLandlordMailingAddress: boolean | null;
  canReceiveRttcComms: boolean | null;
  canReceiveSajeComms: boolean | null;
}

export interface OnboardingStep3Mutation_output_session {
  onboardingScaffolding: OnboardingStep3Mutation_output_session_onboardingScaffolding | null;
}

export interface OnboardingStep3Mutation_output {
  /**
   * A list of validation errors in the form, if any. If the form was valid, this list will be empty.
   */
  errors: OnboardingStep3Mutation_output_errors[];
  session: OnboardingStep3Mutation_output_session | null;
}

export interface OnboardingStep3Mutation {
  output: OnboardingStep3Mutation_output;
}

export interface OnboardingStep3MutationVariables {
  input: OnboardingStep3Input;
}

export const BlankOnboardingStep3Input: OnboardingStep3Input = {
  "leaseType": "",
  "receivesPublicAssistance": ""
};

export const OnboardingStep3Mutation = {
  // The following query was taken from OnboardingStep3Mutation.graphql.
  graphQL: `# This file was auto-generated by querybuilder, please do not edit it.
mutation OnboardingStep3Mutation($input: OnboardingStep3Input!) {
  output: onboardingStep3(input: $input) {
    errors { ...ExtendedFormFieldErrors },
    session {
      onboardingScaffolding { ...OnboardingScaffolding }
    }
  }
}
${ExtendedFormFieldErrors.graphQL}
${OnboardingScaffolding.graphQL}`,
  name: "OnboardingStep3Mutation",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, args: OnboardingStep3MutationVariables): Promise<OnboardingStep3Mutation> {
    return fetchGraphQL(OnboardingStep3Mutation.graphQL, args);
  },
  blankInput: BlankOnboardingStep3Input,
};

export const fetchOnboardingStep3Mutation = OnboardingStep3Mutation.fetch;